// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import fileApi from '~/apis/file';
import { GET_FILE_LIST, UPLOAD_MULTIPLE_FILE_AND_GET_LINK } from '~/utils/constants/actionType';
import { IQueryParamListFile } from '~/utils/interface/file';

export const uploadMultipleFileAndGetLink = createAsyncThunk(
  UPLOAD_MULTIPLE_FILE_AND_GET_LINK,
  async (payload: FormData, { rejectWithValue }) => {
    try {
      const resp = await fileApi.uploadMultipleFileAndGetLink(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListFile = createAsyncThunk(
  GET_FILE_LIST,
  async (params: IQueryParamListFile, { rejectWithValue }) => {
    try {
      const resp = await fileApi.getListFile(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
